// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ab6f115a","453":"77631bc5","455":"d2cbcbaf"}[chunkId] + ".chunk.js";
};